import { render } from "./AutogenView.vue?vue&type=template&id=5838d63f&scoped=true"
import script from "./AutogenView.vue?vue&type=script&lang=js"
export * from "./AutogenView.vue?vue&type=script&lang=js"

import "./AutogenView.vue?vue&type=style&index=0&id=5838d63f&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5838d63f"]])

export default __exports__